import ScrollEffect from './ScrollEffect';

const config = {
  name: 'scrollEffect',
  class: ScrollEffect,
  querySelector: {},
  querySelectorAll: {},
  options: {
    headroom: {
      offset: 300, // @todo could allow component to set this in markup
      tolerance: 0,
      classes: {
        // when element is initialised
        initial: 'scrollEffect',
        // when scrolling up
        pinned: 'scrollEffect--pinned',
        // when scrolling down
        unpinned: 'scrollEffect--unpinned',
        // when above offset
        top: 'scrollEffect--top',
        // when below offset
        notTop: 'scrollEffect--not-top',
        // when at bottom of scoll area
        bottom: 'scrollEffect--bottom',
        // when not at bottom of scroll area
        notBottom: 'scrollEffect--not-bottom',
      },
    },
  },
};

export default config;
